import "../../../src/App.css";
import React, { useState, useEffect } from "react";
import axios from "axios";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import Wrapper from "../../components/UI/Wrapper";

function ChangePassword() {
  const baseAPI = process.env.REACT_APP_API_URL;
  const [pwdMatch, setPwdMatch] = useState("");


  const [formData, setFormData] = useState({
    password: "",
    recheck_password: ""
  });

  const [pwdData, setPwdData] = useState({
    password: "",   
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    setPwdData({
      ...pwdData,
      [name]: value,
    });

    if (name === 'recheck_password') {
      if (value !== formData.password) {

        setPwdMatch("Passwords don't match");
      } else {
        setPwdMatch("Passwords match");

      }
    }
  };



  async function handleSubmit() {
    if (formData.password === formData.recheck_password) {      
      try {
        const storedToken = JSON.parse(localStorage.getItem("token"));
        const response = await axios.post(
          `${baseAPI}userpost/UpdatePassword`,
          pwdData, // Send request body
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        ); 
      } catch (error) {
        console.error("Error posting data:", error);
      }
    }
    else
    {
      alert("Passwords don't match");
    }
  }


  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />
        <div
          className="container-fluid"
          style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            ></div>
            <div>
              <Wrapper className="ViewLeadDetails">
                <div className="container-fluid" styel={{ marginTop: "3rem" }}>

                  <div style={{ marginBottom: "1rem" }}>
                    <span style={{ fontSize: "25px" }}>Change Password</span>
                  </div>
                </div>
                <div className="designationDetail">
                  <form className="designation-form" onSubmit={handleSubmit}>
                    <table style={{ width: "100%" }}>
                      <tr className="tableHeading">
                        <td>New Password*</td>
                        <td>Re-Type Password*</td>
                      </tr>

                      <tr>
                        <td>
                          <input
                            type="password"
                            name="password"
                            value={formData.password}
                            placeholder="Please Enter*"
                            onChange={handleChange}
                            pattern="^(?=.*[a-zA-Z])(?=.*\d).{8,}$"
                            title="Please enter at least 8 characters, including alphanumeric characters."
                          />
                        </td>
                        <td>
                          <input
                            type="password"
                            name="recheck_password"
                            value={formData.recheck_password}
                            placeholder="Please Enter*"
                            onChange={handleChange}
                          />
                        </td>
                      </tr>
                      <tr className="space">
                        <td colSpan={2}>
                          <span>{pwdMatch}</span>
                        </td>
                      </tr>
                    </table>
                    <br />
                    <hr />
                    <div className="reset-addDesignation-button">
                      <button
                        type="submit"
                        style={{
                          marginRight: "10px",
                          backgroundColor: "#5B489D",
                          color: "white",
                        }}
                      >
                        Change Password
                      </button>
                    </div>
                  </form>
                </div>
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ChangePassword;
